import i18n from "features/parent/i18n";
import { AppUser } from "features/user/types";
import { getGenderLabel, calculateAge, formatDate } from "./playerTabUtils";

interface BasicInfoSectionProps {
  selectedUser: AppUser;
  onEditGender: () => void;
  onEditBirthday: () => void;
}

export function BasicInfoSection({
  selectedUser,
  onEditGender,
  onEditBirthday,
}: BasicInfoSectionProps) {
  return (
    <div className="flex-col-el">
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 bg-pink-100/20">
          <span className="material-symbols-outlined text-[30px] text-pink-100">wc</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[18px] text-gray2-100 mb-0.5">
            {i18n.t("MSG_PARENT_PAGE_GENDER")}
          </div>
          <div className="text-[21px] text-textcolor-black">
            {getGenderLabel(selectedUser.gender)}
          </div>
        </div>
        <button
          onClick={onEditGender}
          className="bg-white border border-gray2-60 text-textcolor-black rounded-full py-1.5 px-3 text-[18px] cursor-pointer hover:bg-gray2-20 transition-all"
        >
          {i18n.t("MSG_PARENT_PAGE_CHANGE")}
        </button>
      </div>
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 bg-blue-60/20">
          <span className="material-symbols-outlined text-[30px] text-blue-100">cake</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[18px] text-gray2-100 mb-0.5">{i18n.t("MSG_PARENT_PAGE_AGE")}</div>
          <div className="text-[21px] text-textcolor-black">
            {calculateAge(selectedUser.birthday) !== null
              ? `${calculateAge(selectedUser.birthday)}${i18n.t("MSG_PARENT_PAGE_YEARS_OLD")}`
              : "-"}
          </div>
        </div>
      </div>
      <div className="flex-row-el items-center gap-3 py-3 border-b border-outline overflow-hidden">
        <div className="w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 bg-green-60/20">
          <span className="material-symbols-outlined text-[30px] text-green-100">
            calendar_month
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[18px] text-gray2-100 mb-0.5">
            {i18n.t("MSG_PARENT_PAGE_BIRTHDAY")}
          </div>
          <div className="text-[21px] text-textcolor-black">
            {formatDate(selectedUser.birthday)}
          </div>
        </div>
        <button
          onClick={onEditBirthday}
          className="bg-white border border-gray2-60 text-textcolor-black rounded-full py-1.5 px-3 text-[18px] cursor-pointer hover:bg-gray2-20 transition-all"
        >
          {i18n.t("MSG_PARENT_PAGE_CHANGE")}
        </button>
      </div>
      <div className="flex-row-el items-center gap-3 py-3">
        <div className="w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 bg-gray2-20">
          <span className="material-symbols-outlined text-[30px] text-gray2-100">
            calendar_today
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[18px] text-gray2-100 mb-0.5">
            {i18n.t("MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE")}
          </div>
          <div className="text-[21px] text-textcolor-black">
            {formatDate(selectedUser.created_at)}
          </div>
        </div>
      </div>
    </div>
  );
}
